module.exports = __webpack_public_path__ + "img/icon_bell.bc1a70fb.svg";